module.exports = __webpack_public_path__ + "assets/onboardingOutlookDemoThumbnail_1484px.png";